import { render, staticRenderFns } from "./MarketingPage.vue?vue&type=template&id=7b7876c2&scoped=true&"
import script from "./MarketingPage.vue?vue&type=script&lang=js&"
export * from "./MarketingPage.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPage.vue?vue&type=style&index=0&id=7b7876c2&prod&scoped=true&lang=css&"
import style1 from "./MarketingPage.vue?vue&type=style&index=1&id=7b7876c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7876c2",
  null
  
)

export default component.exports